<template>
  <div class="bgs-resources">
    <inline-loader :loading="loading" v-if="loading" />
    <template v-else>
      <Upload
        class="bgs-resources__upload"
        ref="bgUpload"
        type="drag"
        multiple
        :action="uploadURL"
        :headers="uploadHeaders"
        :default-file-list="fileList || []"
        :show-upload-list="false"
        :on-success="onUploadSuccess"
        :on-error="onUploadError"
        :before-upload="beforeUpload"
      >
        <div class="bgs-resources__upload" style="padding: 8px 0">
          <icon type="ios-cloud-upload" size="16" style="color: #4484ce" />
          <p style="font-size: 12px">
            Загрузить файлы
          </p>
        </div>
      </Upload>

      <resources-upload-list
        v-if="fileList.length"
        style="margin-top: 8px"
        :list="fileList"
        type="bgs"
        @handle-click="handleFileClick"
        @handle-remove="handleFileRemove"
      />

      <inline-loader :loading="uploading" v-if="uploading" />
    </template>

    <modal :z-index="2000" v-model="deleteModal" width="360">
      <p slot="header" style="color:#f60;text-align:center">
        <icon type="ios-information-circle" />
        <span style="margin-left: 4px">Удаление материалов</span>
      </p>
      <div style="text-align:center">
        <p class="ms-text">Вы уверены, что хотите удалить данный документ?</p>
      </div>
      <div slot="footer">
        <i-button
          type="error"
          size="default"
          long
          :loading="deleteLoading"
          @click="deleteFile"
        >
          Удалить
        </i-button>
      </div>
    </modal>
  </div>
</template>

<script>
import InlineLoader from '@/components/loaders/inline-loader'
import ResourcesUploadList from '@/components/resources/editor/resource-upload-list'
import { downloadFile } from '@/utils'
import { mainUrl } from '@/config/urls'

export default {
  props: ['source', 'file-type-id'],
  components: {
    InlineLoader,
    ResourcesUploadList
  },
  watch: {
    'source.id': {
      handler: function (id) {
        if (id) {
          this.getDocuments()
        } else {
          this.fileList = []
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      token: this.$store.state.auth.token,
      downloadUrl: `${mainUrl}/api/download_resource`,
      uploadURL: `${mainUrl}/api/upload_resource`,
      uploadHeaders: { token: this.$store.state.auth.token },
      fileList: [],
      loading: false,
      deleteModal: false,
      deleteLoading: false,
      deletingId: null,
      objectType: 'bank_guarantee_versions',
      uploading: false
    }
  },
  methods: {
    async getDocuments (noloading) {
      try {
        if (!noloading) this.loading = true

        const url = `page/document?object_id=${this.source.id}&file_type_id=${
          this.fileTypeId
        }&object_type=${this.objectType}`
        const response = await this.$store.dispatch('GET_REQUEST', { url })

        this.$set(
          this,
          'fileList',
          Object.values(response['Основной договор'])[0]
        )

        this.updateFileList()
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async onUploadSuccess (response) {
      const { id } = this.source
      const [resource_id] = response
      const data = [
        {
          file_type_id: this.fileTypeId,
          resource_id,
          object_type: this.objectType,
          contract_id: this.$route.params.id
        }
      ]

      if (id) {
        try {
          const url = `page/document?object_id=${id}&object_type=${
            this.objectType
          }&contract_id=${this.$route.params.id}`
          await this.$store.dispatch('POST_REQUEST', { url, data })
          await this.getDocuments(true)

          this.$emit('update')
          this.$Message.success('Файл успешно загружен')
        } catch (error) {
          console.log(error)
        } finally {
          this.uploading = false
        }
      } else {
        this.source.object_resources.push(data[0])
        this.uploading = false
        this.updateFileList()
      }
    },
    onUploadError () {
      this.$Message.error('Произошла ошибка при загрузке файла')

      this.uploading = false
    },
    handleFileClick (resource_id) {
      const url = `${this.downloadUrl}/${resource_id}?access_token=${
        this.token
      }`

      downloadFile(url)
    },
    handleFileRemove (file, name) {
      this.deletingId = file.id || file.response[0]

      if (!this.source.id) {
        this.$refs.bgUpload.fileList = this.$refs.bgUpload.fileList.filter(
          f => f.uid !== file.uid
        )
        this.updateFileList()
      } else {
        this.deleteModal = true
      }
    },
    async deleteFile () {
      const id = this.deletingId

      this.deleteLoading = true

      if (this.source.id) {
        try {
          const url = `page/document?object_id=${this.source.id}&object_type=${
            this.objectType
          }`
          const data = [{ id, disabled: true }]

          await this.$store.dispatch('POST_REQUEST', { url, data })
          await this.getDocuments(true)

          this.$emit('update')
          this.deleteModal = false
          this.deletingId = null
        } catch (error) {
          console.log(error)
        } finally {
          this.deleteLoading = false
        }
      } else {
        this.$set(
          this.source,
          'object_resources',
          this.source.object_resources.filter(f => f.resource_id !== id)
        )

        this.$emit('update')
        this.deleteLoading = false
        this.deleteModal = false
        this.deletingId = null
      }
    },
    updateFileList () {
      setTimeout(() => {
        this.$set(this, 'fileList', this.$refs.bgUpload.fileList)
      }, 100)
    },
    beforeUpload () {
      this.uploading = true
    }
  }
}
</script>

<style lang="less"></style>
